import { BaseService } from '@estee/elc-service';
import { ServiceInitializer } from '@estee/elc-universal-utils';

const { name, version } = __serviceInfo__;

export class SearchService extends BaseService {
    constructor(serviceIntializer: ServiceInitializer) {
        super(name, version, serviceIntializer);
    }
}

export default {
    searchApiSdk: 'SEARCH_API_SDK',
    apiSdk: 'API_SDK',
    configStore: 'CONFIG_STORE',
    httpTransport: 'HTTP_TRANSPORT',
    ratingStore: 'RATING_STORE',
    searchService: 'SEARCH_SERVICE',
    searchResultsViewController: 'SEARCH_RESULTS_VIEW_CONTROLLER',
    searchGnavInputFieldViewController: 'SEARCH_GNAV_INPUT_FIELD_VIEW_CONTROLLER',
    voiceSearchViewController: 'VOICE_SEARCH_VIEW_CONTROLLER',
    searchRepository: 'SEARCH_REPOSITORY',
    config: 'CONFIG',
    configRepository: 'CONFIG_REPOSITORY'
};
